"use strict";

exports.__esModule = true;
exports.EditableLogbookComment = EditableLogbookComment;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _VimanaIcon = require("../../VimanaIcon");
var _Theme = require("../../Theme");
var _LogbookItemDescription = require("./LogbookItemDescription");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var LogbookItemWrapper = _styledComponents["default"].li.withConfig({
  displayName: "EditableLogbookComment__LogbookItemWrapper",
  componentId: "sc-m0vdlb-0"
})(["background:", ";padding:0.5rem 0;margin:0 0.8rem;border-bottom:1px solid ", ";*{width:100%;}"], function (props) {
  return props.theme.LogbookItemBackground;
}, (0, _Theme.val)("LogbookBorderColor"));
var LogbookItem = _styledComponents["default"].div.withConfig({
  displayName: "EditableLogbookComment__LogbookItem",
  componentId: "sc-m0vdlb-1"
})(["width:100%;display:flex;flex-direction:row;"]);
var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "EditableLogbookComment__IconWrapper",
  componentId: "sc-m0vdlb-2"
})(["display:flex;flex:0 0 40px;justify-content:center;align-items:flex-start;padding:0;padding:0.2rem 0 0;color:", ";"], function (props) {
  return props.theme.LogbookMutedTextColor;
});
var ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "EditableLogbookComment__ContentWrapper",
  componentId: "sc-m0vdlb-3"
})(["display:flex;flex:1;justify-content:flex-start;align-items:center;width:100%;*{width:100%;}"]);
function EditableLogbookComment(props) {
  var comment = props.comment,
    ticketComment = props.ticketComment;
  return /*#__PURE__*/_react["default"].createElement(LogbookItemWrapper, null, /*#__PURE__*/_react["default"].createElement(LogbookItem, null, /*#__PURE__*/_react["default"].createElement(IconWrapper, null, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
    margin: "0",
    icon: "CommentsIcon",
    iconSize: 24,
    alt: "Comments"
  })), /*#__PURE__*/_react["default"].createElement(ContentWrapper, null, /*#__PURE__*/_react["default"].createElement(_LogbookItemDescription.LogbookItemDescription, {
    title: comment.body,
    creator: comment.creator,
    created: comment.created,
    editedTimestamp: comment.editedTimestamp,
    ticketComment: ticketComment
  }))));
}